import * as React from 'react';
import { Search } from 'lucide-react';
import { DMDiv, DMInput } from './Primitives';

type DigitalMarketingSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  variant?: 'default' | 'compact';
  className?: string;
  inputClassName?: string;
  iconClassName?: string;
  ariaLabel?: string;
};

export function DigitalMarketingSearchInput({
  value,
  onChange,
  placeholder = 'Search',
  variant = 'default',
  className = '',
  inputClassName = '',
  iconClassName = '',
  ariaLabel,
}: DigitalMarketingSearchInputProps) {
  const isCompact = variant === 'compact';
  const iconBaseClassName = isCompact
    ? 'absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-400'
    : 'absolute left-[1.1vw] top-1/2 h-[2.2vh] w-[2.2vh] -translate-y-1/2 text-gray-700';
  const inputBaseClassName = isCompact
    ? 'w-64 rounded-full border border-gray-200 bg-white py-2.5 pl-10 pr-4 text-sm font-medium text-gray-900 outline-none placeholder:text-gray-500 focus:border-[#5E4DE0] focus:ring-1 focus:ring-[#5E4DE0]'
    : 'h-[6.4vh] w-[19vw] rounded-full border border-gray-300 bg-white pl-[3.5vw] pr-[1.2vw] text-[1.7vh] font-medium text-gray-900 outline-none placeholder:text-gray-500 focus:border-primary-main';

  return (
    <DMDiv className={`relative ${className}`}>
      <Search
        className={`${iconBaseClassName} ${iconClassName}`}
        strokeWidth={2.2}
      />
      <DMInput
        type="search"
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
        className={`${inputBaseClassName} ${inputClassName}`}
      />
    </DMDiv>
  );
}
